(function () {
  'use strict';

  if (window.pefVideoLazyInitialized) return;
  window.pefVideoLazyInitialized = true;

  var reduce = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  var connection = navigator.connection || {};
  var saveData = connection.saveData ||
    /2g/.test(connection.effectiveType || '');

  function playVideo(video) {
    var result = video.play();

    if (result && typeof result.catch === 'function') {
      result.catch(function () {});
    }
  }

  function activateVideo(video) {
    if (reduce || saveData) return;

    if (!video.dataset.pefLazyLoaded) {
      var changed = false;

      if (video.dataset.src && !video.getAttribute('src')) {
        video.setAttribute('src', video.dataset.src);
        changed = true;
      }

      video.querySelectorAll('source[data-src]').forEach(function (source) {
        if (!source.getAttribute('src')) {
          source.setAttribute('src', source.dataset.src);
          changed = true;
        }
      });

      video.dataset.pefLazyLoaded = 'true';

      if (changed) video.load();
    }

    playVideo(video);
  }

  function initialize() {
    var videos = document.querySelectorAll('video.pef-video__media');
    if (!videos.length) return;

    videos.forEach(function (video) {
      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      });

      if (reduce || saveData) {
        video.removeAttribute('autoplay');
        video.pause();
      }
    });

    if (reduce || saveData) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(activateVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activateVideo(entry.target);
        } else {
          entry.target.pause();
        }
      });
    }, {
      rootMargin: '0px',
      threshold: 0.01
    });

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
